import React, { useEffect, useState } from 'react';
import Masonry from 'react-masonry-css';
import { Box, Container } from '@mui/material';

const Gallery = () => {
  const [images, setImages] = useState([]);

  const breakpointColumns = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1
  };

  useEffect(() => {
    // Fetch images from your backend
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const response = await fetch('/.netlify/functions/getImages');
      const data = await response.json();
      setImages(data);
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ padding: 4 }}>
        <Masonry
          breakpointCols={breakpointColumns}
          className="masonry-grid"
          columnClassName="masonry-grid_column"
        >
          {images.map((image) => (
            <Box
              key={image.id}
              sx={{
                margin: 1,
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)',
                },
              }}
            >
              <img
                src={image.url}
                alt={image.title}
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                }}
              />
            </Box>
          ))}
        </Masonry>
      </Box>
    </Container>
  );
};

export default Gallery; 